package com.neurobs.react

import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.ReactElement
import slinky.web.html.{className, div, style}

/**
 * Puts the content in a panel.
 */
@react object Panel {
	case class Props
	(
		fullWidth: Boolean,
		dark: Boolean,
		children: ReactElement*
	)

	val component = FunctionalComponent[Props] { props =>
		val cssClass = "nfw-panel" +
			(if (props.fullWidth) " nfw-panel-full-width" else "") +
			(if (props.dark) " nfw-panel-dark" else "")
		div(
			className := cssClass
		)(
			props.children:_*
		)
	}
}
